export const TIME_SPENT_INTERVAL = 4000;
export const TIME_SPENT_INCREMENT = TIME_SPENT_INTERVAL / 1000;
